(function () {
  if (window.TopRealMedia) return;
  const observed = new WeakSet(), loaded = new WeakMap(), pending = new Set();
  const supportsObserver = 'IntersectionObserver' in window;
  const cssUrl = value => 'url(' + JSON.stringify(value || '') + ')';
  function candidates(element) {
    return (element.dataset.trBgSrcset || '').split(',').map(item => {
      const match = item.trim().match(/^(.*)\s+(\d+)w$/);
      return match ? {src: match[1], width: Number(match[2])} : null;
    }).filter(Boolean).sort((a, b) => a.width - b.width);
  }
  function refresh(element) {
    if (!element.isConnected) { pending.delete(element); return; }
    const box = element.getBoundingClientRect();
    if (!box.width || !box.height) return;
    const style = getComputedStyle(element), ratio = Number(element.dataset.trImageRatio) || 1;
    const contentBox = style.backgroundOrigin === 'content-box';
    const width = box.width - (contentBox ? parseFloat(style.paddingLeft) + parseFloat(style.paddingRight) : 0);
    const height = box.height - (contentBox ? parseFloat(style.paddingTop) + parseFloat(style.paddingBottom) : 0);
    const size = style.backgroundSize === 'contain' ? Math.min(width, height * ratio) : Math.max(width, height * ratio);
    const wanted = size * (window.devicePixelRatio || 1), list = candidates(element);
    const chosen = list.find(item => item.width >= wanted) || list.at(-1) || {src: element.dataset.trImageFull, width: wanted};
    const previous = loaded.get(element), identity = element.dataset.trImageFull;
    if (previous?.identity === identity && previous.width >= chosen.width) return;
    element.style.setProperty('--tr-background-resolved', cssUrl(chosen.src));
    element.classList.add('tr-media-ready');
    loaded.set(element, {...chosen, identity}); pending.delete(element);
  }
  const resize = 'ResizeObserver' in window ? new ResizeObserver(entries => {
    entries.forEach(({target}) => {
      const box = target.getBoundingClientRect();
      if (loaded.has(target) || pending.has(target) && box.top < window.innerHeight + 500 && box.bottom > -500) refresh(target);
    });
  }) : null;
  const observer = supportsObserver ? new IntersectionObserver(entries => {
    entries.forEach(entry => { if (entry.isIntersecting) { refresh(entry.target); if (loaded.has(entry.target)) observer.unobserve(entry.target); } });
  }, {rootMargin: '500px 0px'}) : null;
  function init(root = document) {
    root.querySelectorAll('[data-tr-lazy-bg]').forEach(element => {
      if (observed.has(element)) return;
      observed.add(element); pending.add(element); resize?.observe(element);
      if (observer) observer.observe(element); else refresh(element);
    });
    window.TopRealMediaBoot?.ready();
  }
  function setBackground(element, source) {
    if (!element) return;
    element.dataset.trImageFull = source.src;
    element.dataset.trBgSrcset = source.srcset || '';
    element.dataset.trImageRatio = source.ratio || '1';
    element.style.setProperty('--tr-background-image', cssUrl(source.src));
    loaded.delete(element); refresh(element);
  }
  function setImage(element, source) {
    if (!element) return;
    element.dataset.trImageFull = source.src;
    element.dataset.trImageRatio = source.ratio || '1';
    element.alt = source.alt || '';
    if (source.width) element.width = source.width;
    if (source.height) element.height = source.height;
    if (source.srcset) element.srcset = source.srcset; else element.removeAttribute('srcset');
    element.src = source.src;
  }
  window.TopRealMedia = {init, refresh, setBackground, setImage};
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-tr-lazy-bg]').forEach(element => {observer?.unobserve(element);resize?.unobserve(element);pending.delete(element);});
  });
  window.addEventListener('beforeprint', () => pending.forEach(refresh));
  if (!resize) window.addEventListener('resize', () => document.querySelectorAll('.tr-media-ready[data-tr-lazy-bg]').forEach(refresh), {passive: true});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once: true}); else init();
})();
